<template>
  <div>
    <ModalCover @closeModal="closeAndUpdateModal">
      <!-- MODAL BODY -->
      <div
        slot="modal-cover-body"
        class="back2school-container"
        :style="{
          backgroundImage: `url(${localImg('back2schoolbackground.png')})`,
        }"
      >
        <div class="promo-badge">
          <img v-lazy="localImg('promoBadge.png')" alt="promo" />
        </div>

        <div class="content">
          <img
            v-lazy="'/img/back2SchoolHeading.5b2d265b.png'"
            class="mb-2 heading"
            alt=""
          />

          <ul class="list-unstyled">
            <li class="mb-1">
              <span
                class="icon icon-caret-fill-right brand_accent font-13 mr-3"
              ></span>
              <span class="color_text font-13"
                >50k+ assessments & video lessons</span
              >
            </li>

            <li>
              <span
                class="icon icon-caret-fill-right brand_accent font-13 mr-3"
              ></span>
              <span class="color_text font-13"
                >Daily and weekly improvement reports</span
              >
            </li>
          </ul>

          <div class="mb-4">
            <div class="d-flex align-items-end mb-2">
              <div
                class="line-through brand_tonic font-15 font-weight-600 mr-2"
              >
                ₦15,000
              </div>
              <div class="brand_navy font-20 font-weight-600">
                ₦10,000
              </div>
            </div>

            <div class="font-13 color_text">For 1 Year Access + Free Gift</div>
          </div>

          <button
            class="btn-sm btn btn-sm btn-accent mb-2 ml-0"
            @click="claimOffer"
          >
            CLAIM OFFER NOW
          </button>

          <div class="font-12 color_grey_dark">
            **Offer valid through September only
          </div>
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ModalCover from "@/components/globalComps/ModalCover";

export default {
  name: "BackToSchoolBanner",

  components: {
    ModalCover,
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },

  methods: {
    ...mapActions(["updateNewFeatureLog"]),

    closeAndUpdateModal() {
      // UPDATE b2s CONFIG
      this.updateNewFeatureLog({
        name: "back2School_config",
        type: this.account_type,
      });

      this.$emit("closeTriggered");
    },

    claimOffer() {
      // UPDATE b2s CONFIG
      this.updateNewFeatureLog({
        name: "back2School_config",
        type: this.account_type,
      });

      if (this.account_type === "parent")
        this.$router.push({
          name: "ParentUpgradePlan",
          query: { type: "catchup" },
        });
      else
        this.$router.push({
          name: "StudentUpgradePlan",
          query: { type: "catchup" },
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.back2school-container {
  @include flex_row_between_wrap;
  padding: 30px;
  background-size: 100% 100%;
}

.promo-badge {
  @include equal_min_edge(200);

  @include breakpoint_max(sm) {
    @include equal_min_edge(150);
    margin: auto;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.content {
  width: calc(100% - 230px);

  @include breakpoint_max(sm) {
    width: 100%;
  }
}

.line-through {
  text-decoration: line-through;
}
</style>
